import { render } from "./RolesAndResponsibilitiesView.vue?vue&type=template&id=d98a1ac4&scoped=true"
import script from "./RolesAndResponsibilitiesView.vue?vue&type=script&lang=js"
export * from "./RolesAndResponsibilitiesView.vue?vue&type=script&lang=js"

import "./RolesAndResponsibilitiesView.vue?vue&type=style&index=0&id=d98a1ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98a1ac4"]])

export default __exports__